module.exports = __webpack_public_path__ + "img/dadukou-logo.18fedfa0.jpg";